module.exports = __webpack_public_path__ + "static/talk-2-0e723c6f74be3bb753b449be614dfcb5.png";